/**
 * Client-visible feature flags (`REACT_APP_*`). Must stay aligned with server `ADMIN_PRODUCT_MEMBERSHIP_ENFORCED`
 * semantics when both are enabled in an environment.
 */
export function isAdminProductMembershipEnforced(): boolean {
  const v = String(process.env.REACT_APP_ADMIN_PRODUCT_MEMBERSHIP_ENFORCED ?? '').trim().toLowerCase();
  return v === 'true' || v === '1' || v === 'yes';
}
